export const DEFAULT_LIMIT = 10;
export const ALL_LEADS_PAGE_LIMIT = 5;
